import { SpocContextChangeResponse } from '../../store/api';
import { shopPrefix } from '../../config';
import { SpocRequiredFor } from '../../shared/common/CheckRequiredSpoc/CheckRequiredSpoc';
import { http } from '../axios';

const FETCH_ORDER_REQUIRED_SPOC_URL = `${shopPrefix}/v1/orders/:orderId/requiredspoc`;

export type FetchOrderRequiredSpocResponse = SpocContextChangeResponse;

export const fetchOrderRequiredSpoc = (
    type: SpocRequiredFor,
    orderId: string
): Promise<FetchOrderRequiredSpocResponse> => {
    return http
        .get<SpocContextChangeResponse>(FETCH_ORDER_REQUIRED_SPOC_URL, {
            pathParams: {
                orderId
            }
        })
        .then(response => response.data);
};
